import WebSocketManager from '@/api/websocket'
// import {
//     getStationList,
//     getTotalCapacity
// } from "@/api/screen/screen";
// import useUserStore from "@/store/modules/user";

const useWebSocketStore = defineStore(
    'websocket', {
    state: () => ({
        wsInstance: null,
        connected: false,
        messages: [],
        newMessages: null,
    }),

    actions: {
        async initTotalCapacity () {
            // try {
            //     const res = await getTotalCapacity()
            //     console.log('获取整体可调容量', res)
            //     this.allAdjCapacity = res.data.allAdjCapacity
            //     // 初始化 newMessages
            //     this.newMessages = {
            //         ...res.data
            //     }
            // } catch (error) {
            //     console.error('获取整体可调容量失败:', error)
            // }
        },
        // 初始化 WebSocket 连接
        initWebSocket (randomId) {
            if (this.wsInstance) {
                this.wsInstance.close()
            }

            const wsUrl = `ws://120.27.150.94:8111/websocket/user_${randomId}`
            const ws = WebSocketManager.getInstance(wsUrl, {
                maxReconnectAttempts: 5,
                heartbeatInterval: 30000
            })

            ws.subscribe('open', () => {
                console.log('WebSocket 连接成功')
                this.connected = true
                this.sendInitialRequest(randomId)
            })

            ws.subscribe('close', () => {
                console.log('WebSocket 连接关闭')
                this.connected = false
            })

            ws.subscribe('message', async (event) => {
                try {
                    // 先判断数据类型
                    let data = event
                    if (typeof event === 'string') {
                        data = JSON.parse(event)
                    }
                    console.log('收到消息:', data)
                    this.newMessages = data
                    this.handleMessage(data)
                } catch (error) {
                    console.warn('消息格式不是 JSON 或解析失败，按原始消息处理:', event)
                    // 如果不是 JSON 格式，直接处理原始消息
                    this.handleMessage({
                        type: 'DEFAULT_PUSH',
                        content: event,
                        timestamp: Date.now()
                    })
                }
            })

            ws.subscribe('error', (error) => {
                console.error('WebSocket 错误:', error)
            })

            ws.init()
            this.wsInstance = ws
        },
        /**
         * 发送初始化请求获取数据
         */
        sendInitialRequest (userId) {
            const ws = this.getWebSocket()
            console.log("userId", userId)
            if (ws && this.connected) {
                ws.sendMessage({
                    sid: `user_${userId}`,
                    message: "baseOnline"
                })
            }
        },

        // 处理接收到的消息
        handleMessage (data) {
            try {
                // 如果是心跳消息，直接返回
                if (data.type === 'heartbeat') {
                    return
                }

                switch (data.type) {
                    case 'DEFAULT_PUSH':
                        this.messages.push({
                            ...data,
                            timestamp: data.timestamp || Date.now()
                        })
                        break
                    default:
                        // console.log('未处理的消息类型:', data.type, data)
                        break
                }
            } catch (error) {
                console.error('消息处理错误:', error)
            }
        },

        // 获取 WebSocket 实例
        getWebSocket () {
            return this.wsInstance
        },

        // 获取连接状态
        isConnected () {
            return this.connected
        },

        // 清空消息记录
        clearMessages () {
            this.messages = []
        },
        /**
         * 关闭 WebSocket 连接并清理资源
         */
        closeWebSocket () {
            if (this.wsInstance) {
                this.wsInstance.close()
                this.wsInstance = null
                this.connected = false
                this.clearMessages()
            }
        },
    }
})

export default useWebSocketStore